import { Box, Divider, Link, Typography } from '@mui/material';
import AndroidIcon from '@mui/icons-material/Android';

/**
 * Приложения для Android.
 *
 * Оба собраны отладочным ключом — так их можно поставить на телефон прямо
 * отсюда, но опубликовать в Google Play нельзя: для этого нужен ключ
 * выпуска, а он не должен лежать ни в репозитории, ни на этом сервере.
 * Ссылка честно говорит, что это внутренняя сборка.
 */
const APPS = [
  {
    name: 'Производство',
    href: '/apk/catering-production.apk',
    hint: 'Приёмка, остатки, производство, упаковка, отгрузка, ХАССП',
  },
  {
    name: 'Клиент',
    href: '/apk/catering-client.apk',
    hint: 'Меню, заказы, смета, оплата, переписка с менеджером',
  },
];

export default function AppFooter() {
  return (
    <Box component="footer" className="mt-auto">
      <Divider />
      <Box className="flex flex-col gap-2 px-4 py-3 md:flex-row md:items-center md:gap-6 md:px-6">
        <Typography variant="body2" color="text.secondary">
          Мобильные приложения:
        </Typography>

        <Box className="flex flex-wrap items-center gap-x-5 gap-y-2">
          {APPS.map((app) => (
            <Link
              key={app.href}
              href={app.href}
              title={app.hint}
              underline="hover"
              variant="body2"
              className="flex items-center gap-1"
              // Скачивание, а не переход: без этого браузер на телефоне
              // пытается открыть APK как страницу.
              download
            >
              <AndroidIcon fontSize="small" />
              {app.name}
            </Link>
          ))}
        </Box>

        <Box className="flex-1" />

        <Typography variant="caption" color="text.secondary">
          Сборки для внутреннего использования: подписаны отладочным ключом.
          Android спросит разрешение на установку из этого источника.
        </Typography>
      </Box>
    </Box>
  );
}
